// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'GL accounts'"></sub-header>
  <gl-account-list detail-link="#!/general-ledger/accounts"></gl-account-list>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/accounts/gl-accounts.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;